import React, { useState } from "react";
import { connect } from "react-redux";
import { TextField } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { Formik } from "formik";
import { Link } from "react-router-dom";
import { sendEmail } from '../../crud/auth.crud';
// import Swal from 'sweetalert2';
import BetterAlerts from "../../components/BetterAlerts";
import { useTranslation } from "react-i18next";
import { toAbsoluteUrl } from "../../utils/Utils";

function OauthSuccess(props) {
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);
	const [success_list, setSuccessList] = useState([]);
	const [error_list, setErrorList] = useState([]);


	return (
		<div className='body-reset-password' >
			<div className='card-reset-password' >
				<div style={{ display: 'flex', justifyContent: 'center' }} className='row'>
					<Link to="/" className="kt-login__logo" style={{ display: 'flex', justifyContent: 'center', marginBottom: '50px' }}>
						<img alt="Logo" src={toAbsoluteUrl("/images/logo-dark.png")} style={{ maxWidth: '70%', height: 'auto' }} />
					</Link>
				</div>

				<div className="row">
					<div className='col-sm-12'>
						<center><h3 style={{ marginBottom: '25px' }} className="kt-login__title">{t("OauthSuccess.title")}</h3></center>
						<center><h4 style={{ marginBottom: '40px' }} className="kt-login__subtitle">{t("OauthSuccess.text1")}<br />{t("OauthSuccess.text2")}</h4></center>
					</div>
				</div>
			</div>
		</div>
	);
}

export default connect(null, auth.actions)(OauthSuccess)

